enum SubscriptionMode {
    Trial = 0,
    SingleCopy = 1,
    Regular = 2,
    Print = 3,
    AppDefault = 4,
    AppSingleCopy = 5,
    AppRegular = 6,
    Bundle = 7,
    Unknown = 8,
}

enum SubscriptionStatus {
    Valid = 1,
    Exceed = 2,
    Expired = 4,
    Suspended = 8,
    Canceled = 16,
    PaymentDeclined = 32,
    NotValid = 60,
    NoBalance = 64,
}
interface ISubscriptionProduct {
    balance: number;
    behaviourProfileName: string | null;
    confirmationRequired: boolean;
    externalSubscription: Record<string, unknown>;
    isAutoRenewable: boolean;
    isFree: boolean;
    isUnlimited: boolean;
    maxIssues: number;
    period: IPeriod | null;
    personalHotSpotLimits: IPersonalHotSpotLimits | null;
    showSubscriptionDateAndFee: boolean;
    subscriptionExpirationDate: string;
    subscriptionExpirationDateFormatted: string;
    subscriptionFeeFormatted: string;
    subscriptionId: string;
    subscriptionMonthlyFee: number;
    subscriptionName: string;
    subscriptionRecoveredAndMustBePayed: boolean;
    subscriptionStatus: SubscriptionStatus;
    subscriptionStatusName: string;
    subscriptionMode?: SubscriptionMode;
    isAdditionalIssuesAllowed?: boolean;
    subscriptionBalance?: number;
    maxSessionRequired?: boolean;
    downloadType: string;
}

interface IPersonalHotSpotLimits {
    maxSimultaneousUsers: number;
    maxRadiantHours: number;
    maxLocations: number;
    maxMacFilters: number;
    maxRadiusMeters: number;
}

interface IPeriod {
    type: SubscriptionPeriodType;
    value: number;
}

enum SubscriptionPeriodType {
    Month = 0,
    Day = 1,
}

function isExternallyManagedSubscription(sub: Pick<ISubscriptionProduct, 'behaviourProfileName'> | null | undefined): boolean {
    return !!sub?.behaviourProfileName;
}

export { isExternallyManagedSubscription, ISubscriptionProduct, SubscriptionMode, SubscriptionPeriodType, SubscriptionStatus };
